import { isSearchParamEnabledForAction } from '../../model/search-pages';
import type { AppSearchAction, AppSearchCommitMode } from '../../model/types';

const toUrl = (href: string) => new URL(href, 'http://app.local');

export const mergeCommitHrefs = (selectHref?: string, searchHref?: string) => {
  if (!selectHref) {
    return searchHref;
  }
  if (!searchHref || searchHref === selectHref) {
    return selectHref;
  }

  const selectUrl = toUrl(selectHref);
  const searchUrl = toUrl(searchHref);

  searchUrl.searchParams.forEach((value, key) => {
    if (!selectUrl.searchParams.has(key)) {
      selectUrl.searchParams.set(key, value);
    }
  });

  return `${selectUrl.pathname}${selectUrl.search}`;
};

export const getCommitHref = (
  action: AppSearchAction,
  mode: AppSearchCommitMode,
) => {
  const searchHref = isSearchParamEnabledForAction(action)
    ? action.searchHref
    : undefined;

  if (mode === 'search') {
    return searchHref ?? action.href;
  }
  if (mode === 'select') {
    return action.href;
  }

  return mergeCommitHrefs(action.href, searchHref);
};

export const canOpenAction = (action: AppSearchAction) => Boolean(action.href);

export const canDrillAction = (action: AppSearchAction) =>
  Boolean(action.searchable || action.enterable || action.children?.length);